export const DAILY = 86400;
export const WEEKLY = 604800;
export const MONTHLY = 2592000;
